import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../../../TransfersState'
import BadgeInput from '../../../components/TransferReceive/BadgeInput/BadgeInput'
import Page from '../../../components/TransferReceive/Page/Page'

const ValidateBadge = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(actions.clearState())
  }, [dispatch])

  return (
    <Page headerTitle='Receber Transferência' notRedirect>
      <BadgeInput />
    </Page>
  )
}

export default ValidateBadge
